

import util from '@/api/util'
import StreamRequest from './streamRequest.js'

const token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : ''
const apiurls = util.apiUrl()

// 获取对话标题
export const agentTitle = (content) => {
  return new Promise((resolve) => {
    const headers = {
    accesstoken: token,
      originapi: apiurls,
    }
    let sendMessage = '根据这些内容，生成一个简单的标题，不要包含别的文本内容，标题首尾用*包裹起来，我的内容为：'
    sendMessage += content
    const session = [{ role: 'user', content: sendMessage, id: Date.now(), edit: false }]
    let title = ''
    const streamReq = new StreamRequest({
      url: 'https://user.topeti.com/deepseek/chat',
      data: {
        messages: session,
        model: 'deepseek-chat',
        stream: true,
      },
      responseType: 'arraybuffer',
      headers,
      onMessage: (chunk) => {
        const reslust = processSSEStream(chunk)
        if (reslust?.content) {
          title += reslust.content
        }
      },
      onComplete: () => {
        title = title ? title : '新对话'
        if (title) {
          const match = title.match(/\*(.*?)\*/);
          title = match ? match[1] : title.replace(/[^\w\u4e00-\u9fa5]/g, "")
        }
        resolve(title)
      },
      onError: (error) => {
        console.error('请求出错:', error);
        resolve(false)
      }
    });
    // 开始请求
    streamReq.requestStream();
  })
}

// 根据提示词查询数组
export const aiSearchArray = (arr = [], message) => {
  return new Promise((resolve) => {
    const headers = {
    accesstoken: token,
      originapi: apiurls,
    }
    let sendMessage = JSON.stringify(arr) + '我有一个数组，数组值是一个对象，包含id和tip，根据tip的文本，查询出和' + message + '相匹配的对象，直接给我结果，返回值严格为转换成字符串的数组格式，不要带其他任何语句和文档格式。'
    const session = [{ role: 'user', content: sendMessage, id: Date.now(), edit: false }]
    let content = ''
    const streamReq = new StreamRequest({
      url: 'https://user.topeti.com/deepseek/chat',
      data: {
        messages: session,
        model: 'deepseek-chat',
        stream: true,
      },
      responseType: 'arraybuffer',
      headers,
      onMessage: (chunk) => {
        const reslust = processSSEStream(chunk)
        if (reslust?.content) {
          content += reslust.content
        }
      },
      onComplete: () => {
        let arr = []
        try {
          arr = JSON.parse(content)
        } catch (error) {
          console.log(error, content)
        }
        resolve(arr)
      },
      onError: (error) => {
        console.error('请求出错:', error);
        resolve(false)
      }
    });
    // 开始请求
    streamReq.requestStream();
  })
}

const processSSEStream = (chunk) => {
  // SSE格式通常是 "data: {json}\n\n"
  const lines = chunk.split('\n');
  
  for (const line of lines) {
    // SSE格式
    if (line.startsWith('data: ')) {
      const dataLine = line.substring(6).trim();
      if (dataLine === '[DONE]') {
        return null;
      }
      
      if (dataLine) {
        try {
          const parsedData = JSON.parse(dataLine);
          return extractReasoningContent(parsedData);
        } catch (error) {
          console.warn('解析JSON失败:', error, '原始数据:', dataLine);
        }
      }
    } else {
      // 普通的json格式
      try {
        const parsedData = JSON.parse(line);
        return {
          done: parsedData.done,
          content: parsedData.message.content,
          reasoningContent: parsedData.message.thinking,
        }
      } catch (error) {
        // console.warn('解析JSON失败:', error, '原始数据:', dataLine);
      }
    }
  }
  return null;
}
// 提取reasoning_content
const extractReasoningContent = (data) =>  {
  if (data) {
    let delta
    if (data.choices && data.choices.length > 0) {
      delta = data.choices[0].delta;
    } else if (data.result) {
      delta = data
    }
    if (delta) {
      const reasoningContent = delta.reasoning_content;
      const content = delta.content || delta.result;
      return {
        id: data.id,
        model: data.model,
        reasoningContent: reasoningContent || '',
        content: content || '',
        fullDelta: delta
      };
    }
  }
  
  return null;
}